// Audit log: super admin sign-ins and every change made in the super admin.
// Recorded by the backend (services/adminAudit.js); passwords and codes are never stored.

import { Fragment, useEffect, useState } from "react";
import { get } from "../../utils/apiManager.js";

const card = { background: "#fff", borderRadius: 14, border: "1px solid #edf0f7", boxShadow: "0 1px 4px rgba(26,39,68,.05)", marginBottom: 24 };
const th = { padding: "10px 14px", fontSize: 11, fontWeight: 700, letterSpacing: "0.07em", textTransform: "uppercase", color: "#9aa5c0", textAlign: "left", borderBottom: "1px solid #edf0f7", background: "#f8f9fc", whiteSpace: "nowrap" };
const td = { padding: "10px 14px", fontSize: 13, color: "#3a4a6a", borderBottom: "1px solid #f0f2f8", verticalAlign: "top" };
const btn = { border: "1px solid #d5dbe8", background: "#fff", borderRadius: 8, padding: "6px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", color: "#1a2744" };
const when = (v) => (v ? new Date(v).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—");

const AuditLog = () => {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams({ page: String(page), perPage: "50" });
    if (query) q.set("search", query);
    get(`/admin/audit-log?${q.toString()}`)
      .then((res) => setData(res?.status ? res.data : null))
      .finally(() => setLoading(false));
  }, [page, query]);

  const entries = data?.entries || [];
  const pages = data ? Math.max(1, Math.ceil(data.total / data.perPage)) : 1;
  const failed = (e) => /failed/i.test(e.action);

  return (
    <div style={{ padding: "24px 0" }}>
      <h3 style={{ fontSize: 20, fontWeight: 700, color: "#0a1628", margin: 0 }}>Audit Log</h3>
      <p style={{ margin: "4px 0 16px", color: "#64748b", fontSize: 14 }}>
        Who signed in to the super admin and every change made here, newest first. Passwords and codes are never recorded.
      </p>

      <div style={card}>
        <form onSubmit={(e) => { e.preventDefault(); setQuery(search.trim()); setPage(1); }} style={{ display: "flex", gap: 10, padding: "12px 14px", flexWrap: "wrap" }}>
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search action, admin, company, IP…"
            style={{ padding: "8px 12px", borderRadius: 8, border: "1.5px solid #e2e8f0", fontSize: 14, minWidth: 260, fontFamily: "inherit" }} />
          <button type="submit" style={btn}>Search</button>
          {query && <button type="button" style={btn} onClick={() => { setSearch(""); setQuery(""); setPage(1); }}>Clear</button>}
          {loading && <span style={{ fontSize: 13, color: "#94a3b8", alignSelf: "center" }}>Loading…</span>}
        </form>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>When</th>
                <th style={th}>Admin</th>
                <th style={th}>What</th>
                <th style={th}>On</th>
                <th style={th}>IP</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <Fragment key={e._id}>
                  <tr>
                    <td style={{ ...td, whiteSpace: "nowrap" }}>{when(e.createdAt)}</td>
                    <td style={td}>{e.adminEmail || "—"}</td>
                    <td style={{ ...td, fontWeight: 600, color: failed(e) ? "#b91c1c" : "#0a1628" }}>{e.action}</td>
                    <td style={td}>{e.targetName || e.targetId || "—"}</td>
                    <td style={{ ...td, whiteSpace: "nowrap", color: "#94a3b8" }}>{e.ip || "—"}</td>
                    <td style={{ ...td, textAlign: "right" }}>
                      {e.details && Object.keys(e.details).length > 0 && (
                        <button type="button" style={{ ...btn, padding: "3px 10px", fontSize: 12 }} onClick={() => setOpen(open === e._id ? null : e._id)}>
                          {open === e._id ? "Hide" : "Details"}
                        </button>
                      )}
                    </td>
                  </tr>
                  {open === e._id && (
                    <tr>
                      <td colSpan={6} style={{ ...td, background: "#f8fafc" }}>
                        <pre style={{ margin: 0, fontSize: 12, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{JSON.stringify(e.details, null, 2)}</pre>
                      </td>
                    </tr>
                  )}
                </Fragment>
              ))}
              {!loading && entries.length === 0 && (
                <tr><td colSpan={6} style={{ ...td, textAlign: "center", color: "#94a3b8", padding: 32 }}>Nothing recorded yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        {pages > 1 && (
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", padding: 12 }}>
            <button type="button" style={btn} disabled={page <= 1} onClick={() => setPage(page - 1)}>Newer</button>
            <span style={{ fontSize: 13, color: "#64748b", alignSelf: "center" }}>Page {page} of {pages}</span>
            <button type="button" style={btn} disabled={page >= pages} onClick={() => setPage(page + 1)}>Older</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditLog;
